import React from 'react'


export default function H1P2V(props) {
    return(
        <div data-aos={props.H1P2VEffect} className={props.class} ref={props.refer}>
            <h1>{props.title}</h1>
            <h2>{props.title2}</h2>
            <div>{props.text}</div>
        </div>
    )
}